import { FC } from 'react';
import { useHistory } from 'react-router-dom';

import { useLocalize } from '@treams/treams-hooks';
import { Competency } from '@treams/treams-network';

import SettingsCollection, { ArchiveRestoreMutationTuple } from './SettingsCollection';
import { FormData } from './types';

type Props = {
	formData: FormData;
	libraryPath: string;
};

const SettingsList: FC<Props> = ({ formData, libraryPath }) => {
	const history = useHistory();
	const { localize } = useLocalize();

	const query =
		'variables' in formData.queryForAll ? formData.queryForAll.query : formData.queryForAll;

	const lazyQuery =
		'variables' in formData.lazyQueryForAll
			? formData.lazyQueryForAll.query
			: formData.lazyQueryForAll;

	const variables = {
		...('variables' in formData.queryForAll ? formData.queryForAll.variables : {}),
		...('variables' in formData.lazyQueryForAll ? formData.lazyQueryForAll.variables : {}),
	};

	return (
		<SettingsCollection
			query={query}
			lazyQuery={lazyQuery}
			field={formData.subject.plural}
			translationKey={`settings.${formData.subject.plural}.subheader`}
			title={(data: Competency) => localize(data.title).text}
			link={(data) => `${libraryPath}/${data.id}`}
			variables={variables}
			archive={formData.archive()! as unknown as ArchiveRestoreMutationTuple}
			restore={formData.restore()! as unknown as ArchiveRestoreMutationTuple}
			onAdd={() => history.push(`${libraryPath}/new`)}
		/>
	);
};
export default SettingsList;
